import getDates from "./functions.js";
import WarDate from "./WarDate.js";
import WarStat from "./WarStat.js";
import LifeBasics from "./LifeBasics.js";
import Images from './Images';
import './App.css';
import React, { useState, useEffect, useRef } from "react";
import useIsVisible from './hooks/useIsVisible.js';
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

const App = () => {
  const dates = getDates(new Date(2023, 10 - 1, 8), new Date(2025, 1 - 1, 19));
  const dates2 = getDates(new Date(2025, 3 - 1, 18), new Date(2025, 10 - 1, 10));
  const [currentImage, setCurrentImage] = useState( 0 );
  const [scrollTop, setScrollTop] = useState( 0 );
  const targetDates = useRef();
  const DatesVisible = useIsVisible(targetDates);
  let images = document.getElementsByClassName('genocide-images');
  let lifeBasicsBar = document.getElementsByClassName('life-basics-bar');

  useEffect(() => {
      if (DatesVisible || (scrollTop <= -800 && (window.innerHeight + window.scrollY) < document.body.offsetHeight - 2) ) {
          images[0].style.display = 'block';
          lifeBasicsBar[0].style.display = 'block';
          setTimeout(function () {
              if (currentImage >= Images.length - 1) {
                  setCurrentImage(0);
                  return;
              }
              setCurrentImage(currentImage+1);
          }, 3000 );
      } else if ( images.length || lifeBasicsBar.length ) {
          images[0].style.display = 'none';
          lifeBasicsBar[0].style.display = 'none';
      }
  });

  useScrollPosition(({ prevPos, currPos }) => {
     setScrollTop( currPos.y );
  });

  return (
      <>
          <div className="genocide-images">
              <img src={"images/" + Images[currentImage]} alt=""/>
          </div>
          <div className="stats-genocide-war">
              <WarStat number={74615} word={'Murdered'} />
              <WarStat number={21500} word={"Murdered Child"} />
              <WarStat number={12500} word={"Murdered Woman"} />
              <WarStat number={8000} word={'Missing People'} />
              <WarStat number={175899} word={'Wounded'} />
              <WarStat number={466} word={"Starved to Death"} />
              {/*<WarStat number={157} word={"Child Starved to Death"} />*/}
              {/*<WarStat number={2615} word={"Killed While Ordering Food"} />*/}
              <WarStat number={1701} word={"Murdered Medical staff"} />
              <WarStat number={263} word={"Murdered Journalist"} />
              <WarStat number={7750} word={"Arrested"} />
              <WarStat number={1599} word={"Since Ceasefire"} />
              <LifeBasics/>
          </div>
          <div className="war-date">
              7 Oct, 2023
          </div>
          <div className="dates-genocide-war" ref={targetDates}>
              {dates.map(function (date, i) {
                  return <WarDate key={i} date={date}/>
              })}
              <div className="ceasefire-date">
                  <strong>Ceasefire</strong>
              </div>
              {dates2.map(function (date, i) {
                  return <WarDate key={i} date={date}/>
              })}
              <div className="ceasefire-date">
                  <strong>Ceasefire</strong>
              </div>
              <div className="date-genocide-war">
                  <h4 style={{ textAlign: 'center', marginTop: '35px' }}>Continuous violations and restrictions...</h4>
              </div>
          </div>
          <div className="genocide-war-image">
              <img src="./images/3994629074.jpg" alt="applauding-him-in-congress" />
          </div>
          <p className="criminal-penalty">Criminals will not have living in peace and will not be congratulated for their evil deeds.</p>
      </>
  );
}

export default App;
